





















import { Component, Vue, Provide, Prop, Watch } from "vue-property-decorator";

@Component({
  name: "ContactTwoContactListDialogue"
})
export default class OrderDialogue extends Vue {
  @Prop() ContactTwoContactList!: any; // 联系人二列表

  @Provide() private inputKeyWord: any = ''; // 关键字
  @Provide() private originList: any = this.ContactTwoContactList; // 初始化list
  @Provide() private searchList: any = []; // 搜索后的list

  private onSearch(list:any, keyWord:string) {
    this.searchList = keyWord ? 
      list?.filter((item:any) => this.onFilter(item,keyWord)) 
    : list;
  }

  private onreplace(val:any) {
    return val.toLowerCase().replace(/á/gi,'a').replace(/ñ/gi,'n').replace(/é/gi,'e').replace(/í/gi,'i').replace(/ú/gi,'u').replace(/ó/gi,'o')
  }

  private onFilter(item:any,keyWord:any) {
    return (this.onreplace(item[0])).indexOf(this.onreplace(keyWord)) != -1
  }


  @Watch("inputKeyWord")
  oninputKeyWordChanged(newValue: any) {
    this.inputKeyWord = newValue;
    this.onSearch(this.originList, this.inputKeyWord)
  }

  private mounted() {
  }
  private created() {
    this.searchList = this.originList;
  }
  private closeAction() {
    this.$emit("closeAction", false);
  }
}
